import type { Loadable } from "@/shared/lib/loadable";
import type { FreightMatching } from "@x-mile/api-contract";
import { z } from "zod";

export const addSubscriptionFormSchema = z.object({
  companyId: z.number().min(1, "会社を選択してください"),
});

export type AddSubscriptionFormSchemaType = z.infer<
  typeof addSubscriptionFormSchema
>;

export type OfferCargoSubscription = NonNullable<
  FreightMatching.schemas.GetOffersCargoSubscriptions200["offerCargoSubscriptions"]
>[0];

export type OfferCargoSubscriptionManagementProps = {
  companyId: number;
  subscriptions: Loadable<OfferCargoSubscription[]>;
  companies: Loadable<FreightMatching.schemas.Company[]>;
  addSubscription: (companyId: number) => Promise<void>;
  deleteSubscription: (subscriptionId: number) => Promise<void>;
  isAddingSubscription: boolean;
  isDeletingSubscription: boolean;
};
